import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
declare var $: any;
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable()
export class LikeModalServiceService {

private modalEventEmit = new BehaviorSubject(null);
modalEventObserable = this.modalEventEmit.asObservable();

constructor(private httpClient: HttpClient) { }


modalStatus(status: boolean, data: any) {
  let likeModalData = {
    status: status,
    data: data
  };
  if (status) {
    if (data.likes || data.likeCount) {
      $("#likeModal").modal('show');
      this.modalEventEmit.next(likeModalData);
    }
  } else {
    $(".modal-backdrop").hide();
    $(".modal-open").css('overflow', 'auto');
    $("#likeModal").modal('hide');
    this.modalEventEmit.next(likeModalData);
  }
}


}



// WEBPACK FOOTER //
// ./src/app/shared/services/like-modal-service.service.ts